import { useAuthenticationStore } from "@/stores/authentication"
import { useEstablishmentStore } from "@/stores/establishment"
import { getAccessContract } from "@/utils/contract"

function establishmentHasLocalDiffuser(establishment: {
  local_diffusers?: unknown[]
  has_local_diffuser?: boolean
} | null | undefined): boolean {
  const localDiffusers = establishment?.local_diffusers ?? []

  return localDiffusers.length > 0 || !!establishment?.has_local_diffuser
}

/**
 * Accès au formulaire premium Uska (menu « Fiche établissement »).
 * Utilisateur et plan doivent avoir la feature INFORMATION.
 * Les comptes sans cette feature mais avec un diffuseur local sont redirigés
 * vers Mes échanges.
 */
export default () => {
  const auth = useAuthenticationStore()
  const establishmentStore = useEstablishmentStore()
  const establishment = establishmentStore.currentEstablishment

  const userHasFeature =
    auth.user?.access_features?.find((feature) => feature.code === "INFORMATION") !== undefined
  const productPlan = getAccessContract(establishment)?.product_plan
  const planHasFeature =
    productPlan?.access_features?.find((feature: { code: string }) => feature.code === "INFORMATION") !==
    undefined

  if (userHasFeature && planHasFeature) {
    return { success: true }
  }

  if (establishmentHasLocalDiffuser(establishment)) {
    return { success: false, path: "/mes-echanges" }
  }

  return { success: false, path: "/error" }
}
